async function getDocumentsList(id, page) {
    try {

        if (!id || id === 'undefined') {
            id = null;
        }

        if (!page || page === 'undefined') {
            page = null;
        }
        let response = await BX.ajax.runComponentAction(
            componentBlockDocuments.componentName,
            'getDocuments', {
                mode: 'class',
                signedParameters: componentBlockDocuments.signedParameters,
                data: {
                    templateName: componentBlockDocuments.templateName,
                    params: id,
                    pageNumber: page,
                },
            }).then(function(response) {
            return response;
        });

        return new Promise((resolve, reject) => {
            resolve(response);
        });
    } catch (err) {
        return err.message;
    }
}